import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SchedulerConfigType } from '../../pages/emailAndCalendarIntegration/components/MeetingSchedulerConfig/constants'
import { ReferralLinkItemMeetingLocation } from '../../types/responses/referral-links'
import { RootState } from '../store'

interface EmailAndCalendarIntegrationState {
  visibleAddMeetingLocationModal?: {
    meetingLocation?: ReferralLinkItemMeetingLocation // Only set when editing a modal
    schedulerConfigType: SchedulerConfigType
  }
}

const INITIAL_STATE: EmailAndCalendarIntegrationState = {}

const emailAndCalendarIntegration = createSlice({
  name: 'emailAndCalendarIntegration',
  initialState: INITIAL_STATE,
  reducers: {
    setVisibleAddMeetingLocationModal(
      state,
      action: PayloadAction<
        EmailAndCalendarIntegrationState['visibleAddMeetingLocationModal']
      >,
    ) {
      state.visibleAddMeetingLocationModal = action.payload
    },
  },
})

export const { setVisibleAddMeetingLocationModal } =
  emailAndCalendarIntegration.actions

export const selectEmailAndCalendarIntegration = (state: RootState) =>
  state.emailAndCalendarIntegration

export const selectVisibleAddMeetingLocationModal = createSelector(
  selectEmailAndCalendarIntegration,
  (state) => state.visibleAddMeetingLocationModal,
)

export const emailAndCalendarIntegrationReducer =
  emailAndCalendarIntegration.reducer
